import React, { useMemo, useState } from 'react';

import { isActiveOptionsList } from './constants';
import { PromotionBasicsCard } from '../component/Promotions/PromotionBasicsCard';
import { PromotionPageShell } from '../component/Promotions/PromotionPageShell';
import { usePromotionCountryCurrency } from '../hooks/usePromotionCountryCurrency';

export const CreateReactivationPromotion = () => {
  const isActiveOptions = useMemo(() => isActiveOptionsList, []);

  // basics
  const [promotionName, setPromotionName] = useState('');
  const [isActive, setIsActive] = useState(isActiveOptions[0]);

  // shared country/currency sync
  const { eligibleCountry, currency, handleCountryChange, handleCurrencyChange } =
    usePromotionCountryCurrency();

  return (
    <PromotionPageShell
      title="Create Plan Reactivation Promotion"
      description="This promotion will apply to plan reactivations only. When this promotion is active, the free product(s) will be displayed in the Review and Confirm page for the plan the customer is reactivating, as well as a free gift indicator in the order cards on the Home tab."
    >
      <PromotionBasicsCard
        promotionName={promotionName}
        setPromotionName={setPromotionName}
        isActive={isActive}
        isActiveOptions={isActiveOptions}
        setIsActive={setIsActive}
        currency={currency}
        eligibleCountry={eligibleCountry}
        onCurrencyChange={handleCurrencyChange}
        onCountryChange={handleCountryChange}
      />
    </PromotionPageShell>
  );
};
